export function initAnimatedLogos() {
    // Cerchiamo se esiste almeno un logo da animare (escludendo quelli già visibili)
    const hasLogoComponents = document.querySelector('.logo-square-fx:not(.is-visible)');

    if (hasLogoComponents) {
        import('./animated_logos.js')
            .then(module => {
                module.default();
            })
            .catch(err => {
                console.error('Errore nel caricamento del modulo Logo FX:', err);
            });
    }
}
